import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {AQH_STA_0, AQH_STA_1, AQH_STA_2} from '../models/input.module';
import {map} from 'rxjs/operators';
import {CountryResponse} from '../models/response.module';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StaticService {

  constructor(private endpointService: EndpointService) {
  }

  getHorseRegistries() {
    let payload: AQH_STA_0 = {};
    return this.endpointService.aqh_sta_0(payload).pipe(map((data => {
      return data;
    })))
  }

  getMembershipPlans() {
    let payload: AQH_STA_1 = {};
    return this.endpointService.aqh_sta_1(payload).pipe(map((data => {
      return data.data;
    })))
  }

  getCountries(): Observable<CountryResponse[]> {
    let payload: AQH_STA_2 = {};
    return this.endpointService.aqh_sta_2(payload).pipe(map((data => {
      return data.data;
    })))
  }

}
